import QueryEmployeeBookings from "graphql/queries/QueryEmployeeBookings";
import _ from "lodash";
import HelperCollection from "utils/helper-collection";
import { constantsActive } from "utils/constants/constants";
import ObjectBooking from 'utils/objects/booking'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import QueryEmployeeBookingsByGuids from 'graphql/queries/QueryEmployeeBookingsByGuids'
import HelperDate, { dateFormat } from 'utils/helper-date'

const FetchBooking = {
	
	monthsFetched: {},
	
	createRange: ( date ) => {
		return {
			from: HelperDate.date( date ).startOf("month" ).format( dateFormat.DATE ),
			till: HelperDate.date( date ).add( 1, 'month').endOf( "month" ).format( dateFormat.DATE )
		};
	},
	
	fetch: ( date, { employeeGuid = '::employee_guid', callbackSuccess = null, callbackError = null, callbackStart = null, dispatchDataToStore = false } = {} ) => {
		const bookingDate = [];
		if( _.isObject( date ) ) {
			_.forEach( date, ( v, k ) => {
				switch( k ) {
					case 'from':
						bookingDate.push( v +'_after_equal' );
						break;
						
					case 'till':
						bookingDate.push( v +'_before_equal' );
						break;
				}
			})
		} else {
			bookingDate.push( date );
		}
		
		GraphqlGroupedBuilder.addQuery( 'bookings', QueryEmployeeBookings, {
			variables: {
				guid: employeeGuid,
				booking_date: bookingDate,
				active: [
					constantsActive.YES
				]
			},
			resultPath: [ 'employee' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess( {
						employee: result,
						bookings: FetchBooking.process( _.get( result, ['bookings'], [] ) ),
					} );
				}
			}
		})
	},

	fetchByGuid: ( guid, employeeGuid, { callbackSuccess = null, callbackError = null, callbackStart = null, dispatchDataToStore = false } = {} ) =>{
		GraphqlGroupedBuilder.addQuery( 'bookings', QueryEmployeeBookingsByGuids, {
			variables: {
				guid: employeeGuid,
				booking_guids: [
					guid
				],
				active: [
					constantsActive.YES
				]
			},
			resultPath: [ 'employee' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess( _.get( result, ['bookings'], [] ) );
				}
			}
		})
	},
	
	fetchRange: ( date, { employeeGuid = '::employee_guid', callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		const monthKey = date.format('YYYY-MM' );
		
		const monthFetched = _.get( FetchBooking.monthsFetched, [employeeGuid, monthKey], null );
		const xMinutesAgo = HelperDate.date().subtract(2, 'minutes')
		
		// Check if it is set or is older than x minutes
		if( monthFetched !== null && monthFetched.isAfter( xMinutesAgo ) ) {
			if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
				callbackSuccess( {
					bookings: {}
				} );
			}
			return;
		}
		
		// Add to the array
		FetchBooking.monthsFetched[ employeeGuid ] = {
			...FetchBooking.monthsFetched,
			[ monthKey ]: HelperDate.date()
		}
		
		FetchBooking.fetch( FetchBooking.createRange( date ), {
			employeeGuid: employeeGuid,
			callbackStart: callbackStart,
			callbackSuccess: callbackSuccess,
			callbackError: callbackError
		} );
	},
	
	resetMonthsFetched: ( { employeeGuid = '::employee_guid' } = {} ) => {
		FetchBooking.monthsFetched[ employeeGuid ] = {};
	},
 
	process: ( bookings ) => {
		return ObjectBooking.prepareForRedux(
			HelperCollection.filterWithoutGuid(
				bookings
			)
		)
	}
}

export default FetchBooking
